import * as t from 'io-ts';

import { RegistrationDetailsTypes } from '../../../utils/WebinarRegistrationUtils/types';

export class SegmentEventRegistrationDetails {
  webinar1DateTime!: string | undefined;
  webinar1Date!: string | undefined;
  webinar2DateTime!: string | undefined;
  cycle!: string | undefined;
  constructor(
    segementEventRegistrationDetails: t.TypeOf<typeof RegistrationDetailsTypes>
  ) {
    this.webinar1DateTime = segementEventRegistrationDetails.webinar1_date_time;
    this.webinar1Date = segementEventRegistrationDetails.webinar1_date;
    this.webinar2DateTime = segementEventRegistrationDetails.webinar2_date_time;
    this.cycle = segementEventRegistrationDetails.cycle;
  }
}
